import Vue from 'vue';
import 'babel-polyfill';
import 'es6-promise/auto';
import FastClick from 'fastclick';
import App from './App';
import router from './routes';
import store from './stores';
import Dialog from './components/Dialog/index';
import VuePreview from './components/preview/index';
import {Track, TrackLisener} from '@bbt/mt-utils-tracking';

// 埋点方法
window.Track = Track;
TrackLisener.addClickListenner();
window.Tracking = {
  initTrackUrl: (logEvent, trackCode, toHref, orderNo, tCode) => {
    Track.doTracker(logEvent, trackCode, toHref, orderNo, tCode);
  }
};

window.addEventListener('load', () => {
  FastClick.attach(document.body);
});

// 安装对话框插件
Vue.use(Dialog);
Vue.use(VuePreview);

// 对登录过期的进行判断
router.beforeEach((to, from, next) => {
  // 登录校验
  if (to.meta.requiresAuth) {
    if (!window.token) {
      location.href = 'http://m.meitun.com/inquiry/';
      return;
    }
  }
  next();
});

// 创建vue实例并渲染到app
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');

Vue.config.devtools = true;



// WEBPACK FOOTER //
// ./src/main.js